export default "__VITE_ASSET__CPg0wjj4__"